import NameTranslationMapper from "../../core/service/translations/NameTranslationMapper";
import { formatBooleanValue } from "../../util";
import OrganisationIndex from "../model/OrganisationIndex";

const OrganisationIndexMapper = (item: any) => {
  let organisationIndex = OrganisationIndex(item);
  organisationIndex.valid = formatBooleanValue(item.valid);
  organisationIndex.harmonized = formatBooleanValue(item.harmonized);
  organisationIndex.nameTranslations = (item.nameTranslations || []).map(
    (elem) => NameTranslationMapper(elem)
  );
  return organisationIndex;
};

export default OrganisationIndexMapper;
